export default function CTASection() {
  return (
    <section className="py-20 bg-amber-500">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          Ready to Start Shopping?
        </h2>
        <p className="text-amber-100 text-base md:text-lg mb-8 max-w-xl mx-auto">
          Access the full ACBuy Spreadsheet 2026 — 100,000+ products, QC photos, hipobuy shipping coupons and more. Free, no sign-up needed.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://repsw2c.com/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="px-8 py-4 bg-white hover:bg-gray-100 text-amber-600 font-bold text-base rounded-md transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-file-list-3-line mr-2"></i>
            acbuy2026spreadsheet shipping
          </a>
          <a
            href="https://repsw2c.com/"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="px-8 py-4 bg-amber-700 hover:bg-amber-800 text-white font-bold text-base rounded-md transition-colors whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-shopping-bag-line mr-2"></i>
            Buy It Now
          </a>
        </div>
      </div>
    </section>
  );
}
